export default __webpack_public_path__ + "static/media/TG.efe1551a.ico";